<template>
  <div class="home">
    <div class="admin-link"><a href="/admin"></a></div>
    <RegionList @region-selected="openRegionModal" />
    <GalleryModal 
      :show="showModal" 
      :region="selectedRegion"
      :current-language="currentLanguage"
      @close="closeModal"
    />
    <div class="footer">
      <div class="lang-container">
        <LanguageSwitcher @language-changed="handleLanguageChange" />
      </div>
      <div class="open-message">Click a pin to open the message.</div>
    </div>
  </div>
</template>

<script>
import RegionList from '../components/RegionList.vue'
import GalleryModal from '../components/GalleryModal.vue'
import LanguageSwitcher from '../components/LanguageSwitcher.vue'

export default {
  name: 'HomeView',
  components: {
    RegionList,
    GalleryModal,
    LanguageSwitcher
  },
  data() {
    return {
      showModal: false,
      selectedRegion: null,
      currentLanguage: 'en'
    }
  },
  methods: {
    openRegionModal(region) {
      this.selectedRegion = region
      this.showModal = true
    },
    closeModal() {
      this.showModal = false
    },
    handleLanguageChange(language) {
      this.currentLanguage = language
    }
  }
}
</script>

<style scoped>
.admin-link {
  height: 50px;
  width: 50px;
}

.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
}

.lang-container {
  margin-left: auto;
}

.open-message {
  color: #666;
  font-size: 14px;
}
</style>